import { render, staticRenderFns } from "./user-block.vue?vue&type=template&id=b574b728&"
import script from "./user-block.vue?vue&type=script&lang=js&"
export * from "./user-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports